import { t } from "@lingui/core/macro";

export function RegrelloFormFieldEmptyValueEmpty() {
  return <span className="text-textPlaceholder">{t`Empty`}</span>;
}
